export default function maskmoney(){
    $(function($) {
        if(document.querySelector("#value")){
            $("#value").maskMoney({prefix:"R$ ", allowNegative: true, thousands:".", decimal:",", affixesStay: false,});
        }
    });
}